const Colors = {
  background: "hsl(214, 28%, 38%)",
  foreground: "#549cf1",
};

export default Colors;
